import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Subject } from "rxjs";
import { filter, takeUntil } from "rxjs/operators";

import { environment } from "../../../../environments/environment";
import { ConfigService } from "../../../core/services/config.service";
import { PlayerHudStatsService } from "../../../core/services/player-hud-stats.service";
import {
  HudThemeStatistic,
  PlayerHudStatistic,
} from "../../models/table-hud-statistic";

export interface PlayerHudStatsDialogData {
  playerId: number;
  playerName: string;
  avatarUrl?: string;
  hudThemeId?: number | null;
  isHero?: boolean;
  tableHudStat?: PlayerHudStatistic | null;
}

@Component({
  selector: "app-player-hud-stats-dialog",
  templateUrl: "./player-hud-stats-dialog.component.html",
  styleUrls: ["./player-hud-stats-dialog.component.scss"],
})
export class PlayerHudStatsDialogComponent implements OnInit, OnDestroy {
  stats: HudThemeStatistic | null = null;
  loading = true;
  avatarSrc = "";

  private readonly destroy$ = new Subject<void>();

  constructor(
    public dialogRef: MatDialogRef<PlayerHudStatsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PlayerHudStatsDialogData,
    private playerHudStatsService: PlayerHudStatsService,
    public configService: ConfigService,
  ) { }

  get isNewDesign(): boolean {
    return !!this.configService.config?.newDesign;
  }

  get isCantobyte(): boolean {
    return (
      this.configService.config?.brand === "cantobyte" ||
      !!this.configService.config?.newDesign
    );
  }

  ngOnInit() {
    this.avatarSrc = this.resolveAvatarUrl(this.data.avatarUrl);
    this.loadStats();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  close() {
    this.dialogRef.close();
  }

  onMyStatsClick() {
    // Placeholder until detailed lobby stats view is implemented.
  }

  formatPercent(value?: number): number {
    return Math.round(value ?? 0);
  }

  formatHands(value?: number): number {
    return value ?? 0;
  }

  private loadStats() {
    if (this.data.tableHudStat) {
      this.stats = this.data.tableHudStat;
      this.loading = false;
    }

    this.playerHudStatsService.tableHudStatsUpdated$
      .pipe(
        takeUntil(this.destroy$),
        filter((response) => response.playerId === this.data.playerId),
      )
      .subscribe((response) => {
        this.stats = response.stat;
        this.loading = false;
      });
  }

  private resolveAvatarUrl(avatarUrl?: string): string {
    if (!avatarUrl) {
      return this.defaultSkinAvatar;
    }
    if (avatarUrl.startsWith("http")) {
      return avatarUrl;
    }
    return `${this.configService.config.httpUrl}/avatar/${avatarUrl}`;
  }

  get defaultSkinAvatar(): string {
    return `${environment.dataSource}/assets/${this.configService.config.code}/player/avatar.png`;
  }
}
